import { fadeIn } from '@/v2/constants/motion'
import { PressNewsType } from '@/v2/types/cards'
import { domAnimation, LazyMotion, m } from 'framer-motion'
import Image from 'next/image'
import React from 'react'
import { Autoplay, Navigation, Pagination } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

const PREV_ICON_PATH = 'M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z'
const NEXT_ICON_PATH = 'M8.59 16.59 10 18l6-6-6-6-1.41 1.41L13.17 12z'

interface PressSliderProps {
  articles: PressNewsType[]
}

const PressSlider: React.FC<PressSliderProps> = props => {
  const { articles } = props

  return (
    <LazyMotion features={domAnimation}>
      <m.div variants={fadeIn('up', 'spring', 0, 1)} className='press-release-carousel relative'>
        <button type='button' className='press-release-prev' aria-label='Previous news'>
          <svg viewBox='0 0 24 24' aria-hidden='true'>
            <path d={PREV_ICON_PATH} />
          </svg>
        </button>
        <button type='button' className='press-release-next' aria-label='Next news'>
          <svg viewBox='0 0 24 24' aria-hidden='true'>
            <path d={NEXT_ICON_PATH} />
          </svg>
        </button>

        <Swiper
          modules={[Navigation, Pagination, Autoplay]}
          navigation={{
            prevEl: '.press-release-carousel .press-release-prev',
            nextEl: '.press-release-carousel .press-release-next'
          }}
          pagination={{ clickable: true }}
          className='client-say-carousel'
          spaceBetween={20}
          slidesPerView={3}
          loop={true}
          autoplay={{
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
          }}
          breakpoints={{
            375: {
              slidesPerView: 1,
              spaceBetween: 16
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 20
            },
            1024: {
              slidesPerView: 3,
              spaceBetween: 24
            }
          }}
        >
          {articles?.map(article => (
            <SwiperSlide key={article.id}>
              <article className='flex h-full flex-col text-left'>
                <div className='relative mb-4 aspect-[13/7] w-full overflow-hidden'>
                  <Image
                    fill
                    src={article.image.src}
                    alt={article.image.alt}
                    className='h-full w-full object-cover object-center'
                    sizes='(min-width: 1024px) 33vw, (min-width: 768px) 50vw, 100vw'
                  />
                </div>
                <p className='pb-2.5 text-[13px] font-normal text-paragraph'>{article.date}</p>
                <p className='min-h-24 line-clamp-4 text-base font-normal leading-6 text-paragraph'>{article.title}</p>
                <a
                  href={article.href}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='mt-auto pt-5 text-sm font-medium text-heading-home underline underline-offset-4'
                >
                  Read full post
                </a>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </m.div>
    </LazyMotion>
  )
}

export default PressSlider
